import $ from 'jquery';
class Colours {

    constructor(){
        if ($("#colours-upload-button").length != 0){
            this.events();
        }
    }

    events() {
        //  Register Listeners
        $("#colours-upload-button").on("click", this.coloursButtonPressed.bind(this));
    }

    //  Methods
    coloursButtonPressed(e){
        $("#colours-upload-button").addClass("d-none");
        $("#colours-upload-form").removeClass("d-none");
    }
}
export default Colours;